import createRoute   from '@widesk-ui/tools/createRoute';
import PlanningModel from '@models/website/PlanningModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/plannings',
	'website',
	'PlanningSplitView',
	PlanningModel.localize('plural'),
);
export default route;
